import { render, staticRenderFns } from "./OtherSales.vue?vue&type=template&id=3f69fa7e&scoped=true"
import script from "./OtherSales.vue?vue&type=script&lang=js"
export * from "./OtherSales.vue?vue&type=script&lang=js"
import style0 from "./OtherSales.vue?vue&type=style&index=0&id=3f69fa7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69fa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f69fa7e')) {
      api.createRecord('3f69fa7e', component.options)
    } else {
      api.reload('3f69fa7e', component.options)
    }
    module.hot.accept("./OtherSales.vue?vue&type=template&id=3f69fa7e&scoped=true", function () {
      api.rerender('3f69fa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/OtherSales.vue"
export default component.exports